module.controller('sampleTaskTakeFormCtrl', [ '$document', '$timeout', '$scope', '$state', 'planSamplingService', 'alertService', 'dateUtilService', 'ASEBIOL_CONSTANTS',
		'FileUploader', 'Upload', sampleTaskTakeFormCtrlFn ])

function sampleTaskTakeFormCtrlFn($document, $timeout, $scope, $state, planSamplingService, alertService, dateUtil, ASEBIOL_CONSTANTS, FileUploader, Upload) {
	var vm = this;

	$scope.maxDate = moment();

	vm.uploaderTermobutton = new FileUploader();

	vm.DATETIME_FORMAT = dateUtil.DateTimeFormatMomentShow;
	vm.DATE_FORMAT = dateUtil.DateFormatShow;
	vm.REGEX_SIGNED2DECIMAl = ASEBIOL_CONSTANTS.REGEX_SIGNED2DECIMAl;
	vm.REGEX_2DECIMAl = ASEBIOL_CONSTANTS.REGEX_2DECIMAl;

	var vmparent = $scope.$parent.ctrl;
	
	vm.loading = false;

	vm.validation = {
		observations : {
			maxlength : 500
		},
		packing : {
			maxlength : 200
		},
		clientName : {
			maxlength : 200
		}
	};
	
	vm.takenInfo = {
		date : moment(),
		amountUnits : {},
		productionArrivalType : true
	};

	vm.nontaken = {

	};

	vm.isCollapse = true;

	vm.productionArriveDateOption = {
		maxDate : new Date()
	};

	vm.loadPhoto = false;

	var duration = 1000; // milliseconds
	var offset = 40;

	function init() {

		if (vmparent.sample && vmparent.isTaken()) {
			vm.takenInfo.date = vmparent.sample.takenDate;
			vm.takenInfo.productionArrivalDate = vmparent.sample.productionArrivalDate.toDate();
			vm.takenInfo.expirationDate = vmparent.sample.expirationDate.toDate();
			vm.takenInfo.setNumber = vmparent.sample.setNumber; // lote
			vm.takenInfo.temperature = vmparent.sample.temperature;
			vm.takenInfo.ph = vmparent.sample.ph;
			vm.takenInfo.orp = vmparent.sample.orp;
			vm.takenInfo.chlorineTotal = vmparent.sample.chlorineTotal;
			vm.takenInfo.chlorineFree = vmparent.sample.chlorineFree;
			vm.takenInfo.chlorineCombined = vmparent.sample.chlorineCombined;
			vm.takenInfo.observations = vmparent.sample.takeObservation;
			vm.takenInfo.productionArrivalType = getConstantById(PRODUCTION_ARRIVAL_TYPE, vmparent.sample.productionArrivalType).value;
			vm.takenInfo.amount = vmparent.sample.amount;
			vm.takenInfo.packing = vmparent.sample.packing;
			vm.takenInfo.detail = vmparent.sample.detail;
			vm.takenInfo.thermoButton = vmparent.sample.thermoButton;

			// vm.takenInfo.samplingMethod = [ {
			// id : vmparent.sample.samplingMethod.id,
			// name : vmparent.sample.samplingMethod.name,
			// uncertainty : vmparent.sample.samplingMethod.uncertainty
			// } ]

			vm.takenInfo.amountUnits = {
				selected : [ {
					id : vmparent.sample.amountUnits.id,
					name : vmparent.sample.amountUnits.name,
					value : vmparent.sample.amountUnits.value,
					category : vmparent.sample.amountUnits.category,
					parent : vmparent.sample.amountUnits.parent,
					type : vmparent.sample.amountUnits.type
				} ]
			}
		}
	}
	vm.changeDate = function(type) {
		console.log(type);
	}

	function takeSample() {
console.log("take sample for andres");
		var scopeChild = $scope.$$childTail;
		console.log(scopeChild);

		// vm.widthSignature = 800;

		vm.takenInfo.date = moment();
		$scope.maxDate = moment();

		var takeModel = {
			amount : vm.takenInfo.amount,
			temperature : vm.takenInfo.temperature,
			productionArrivalDate : dateUtil.date2String(vm.takenInfo.productionArrivalDate),
			expirationDate : dateUtil.date2String(vm.takenInfo.expirationDate),
			takenDate : dateUtil.datetime2String(vm.takenInfo.date),
			packing : vm.takenInfo.packing,
			takeObservation : vm.takenInfo.observations,
			setNumber : vm.takenInfo.setNumber,
			idAmountUnits : vm.takenInfo.amountUnits.selected[0].id,
			productionArrivalType : PRODUCTION_ARRIVAL_TYPE.PRODUCTION_DATE.enumName
		}

		if (!angular.isUndefined(vm.takenInfo.productionArrivalType)) {
			if (vm.takenInfo.productionArrivalType)
				takeModel.productionArrivalType = PRODUCTION_ARRIVAL_TYPE.PRODUCTION_DATE.enumName;
			else
				takeModel.productionArrivalType = PRODUCTION_ARRIVAL_TYPE.ARRIVAL_DATE.enumName;
		}
		if (vmparent.sample.sampling.product.category.requiredTakePhoto)
			takeModel.takePhoto = vm.takenInfo.takePhoto.urlData;

		if (vm.takenInfo.chlorineTotal)
			takeModel.chlorineTotal = vm.takenInfo.chlorineTotal;

		if (vm.takenInfo.chlorineFree)
			takeModel.chlorineFree = vm.takenInfo.chlorineFree;

		if (vm.takenInfo.chlorineCombined)
			takeModel.chlorineCombined = vm.takenInfo.chlorineCombined;

		if (vm.takenInfo.ph)
			takeModel.ph = vm.takenInfo.ph;

		if (vm.takenInfo.orp)
			takeModel.orp = vm.takenInfo.orp;

		if (vm.takenInfo.detail)
			takeModel.detail = vm.takenInfo.detail;

		if (!isEmpty(vm.takenInfo.thermoButton)) {
			takeModel.thermoButton = vm.takenInfo.thermoButton;
		}

		// console.log(takeModel)

		alertService.showSwtQuestion('Enviar información de toma de muestra', function() {
			vm.loading = true;
			planSamplingService.takeSample($scope.ctrl.idPlanSampling, $scope.ctrl.idSampling, $scope.ctrl.idSample, takeModel).then(function(response) {

				if ($scope.refreshSample)
					$scope.refreshSample($scope.ctrl.idPlanSampling, $scope.ctrl.idSampling, $scope.ctrl.idSample);
				$scope.ctrl.reloadData();
				alertService.showSuccess('Muestra tomada satisfactoriamente');
				vm.isCollapse = true;
				scrollToTake();

				vm.loading = false;
			}, function(response) {
				vm.loading = false;
			});
		});

	}

	/*
	 * update sample
	 */

	function updateTakeSample() {

		var scopeChild = $scope.$$childTail;
		if (!$scope.$$childTail.accept)
			scopeChild = $scope.$$childHead;
		var takeSampleForm = scopeChild.takeSampleForm;
		if (!scopeChild.submitted)
			return;

		if (takeSampleForm.$invalid) {
			alertService.showSwtWarningQuestionRaw('Error en el formulario', 'por favor verifique la información', false, undefined);
			return;
		}

		var updateTakeModel = {
			amount : vm.takenInfo.amount,
			packing : vm.takenInfo.packing,
			temperature : vm.takenInfo.temperature,
			productionArrivalDate : dateUtil.date2String(vm.takenInfo.productionArrivalDate),
			expirationDate : dateUtil.date2String(vm.takenInfo.expirationDate),
			takenDate : dateUtil.datetime2String(vm.takenInfo.date),
			takeObservation : vm.takenInfo.observations,
			setNumber : vm.takenInfo.setNumber,
			idAmountUnits : vm.takenInfo.amountUnits.selected[0].id,

		}

		if (!angular.isUndefined(vm.takenInfo.productionArrivalType)) {
			if (vm.takenInfo.productionArrivalType)
				updateTakeModel.productionArrivalType = PRODUCTION_ARRIVAL_TYPE.PRODUCTION_DATE.enumName;
			else
				updateTakeModel.productionArrivalType = PRODUCTION_ARRIVAL_TYPE.ARRIVAL_DATE.enumName;
		}

		if (vm.takenInfo.chlorineTotal)
			updateTakeModel.chlorineTotal = vm.takenInfo.chlorineTotal;

		if (vm.takenInfo.chlorineFree)
			updateTakeModel.chlorineFree = vm.takenInfo.chlorineFree;

		if (vm.takenInfo.chlorineCombined)
			updateTakeModel.chlorineCombined = vm.takenInfo.chlorineCombined;

		if (vm.takenInfo.ph)
			updateTakeModel.ph = vm.takenInfo.ph;

		if (vm.takenInfo.orp)
			updateTakeModel.orp = vm.takenInfo.orp;

		if (vm.takenInfo.detail)
			updateTakeModel.detail = vm.takenInfo.detail;

		if (!isEmpty(vm.takenInfo.thermoButton)) {
			updateTakeModel.thermoButton = vm.takenInfo.thermoButton;
		}

		alertService.showSwtQuestion('Enviar información de toma de muestra', function() {
			vm.loading = true;
			planSamplingService.updateTakeSample($scope.ctrl.idPlanSampling, $scope.ctrl.idSampling, $scope.ctrl.idSample, updateTakeModel).then(function(response) {

				if ($scope.refreshSample)
					$scope.refreshSample($scope.ctrl.idPlanSampling, $scope.ctrl.idSampling, $scope.ctrl.idSample);
				$scope.ctrl.reloadData();
				alertService.showSuccess('Muestra actualizada satisfactoriamente');
				vm.isCollapse = true;

				scrollToTake();

				vm.loading = false;

			}, function(response) {
				vm.loading = false;
			});
		});

	}
	/*
	 * submit button
	 */
	vm.OnSubmit = function() {

		if (vmparent.sample.state == SAMPLE_STATE.SAMPLE_ELEMENT_CHECKED.enumName){
			takeSample();
		}else{
//		if (vmparent.sample.state == SAMPLE_STATE.TAKEN.enumName)
			updateTakeSample();
		}
	}

	/*
	 * select method
	 */
	// vm.samplingMethod = function(id) {
	// vm.takenInfo.samplingMethod[0].id = id;
	// }
	/*
	 * options production-Arrive
	 */
	/*
	 * vm.productionArriveOptions = function(id) {
	 * vm.takenInfo.productionArrivalType = id; }
	 */
	vm.nontakenSample = function() {
		alertService.showSwtWarningQuestion("Muestra #" + $scope.ctrl.sample.idSample + " no Tomada", function() {
			vm.loading = true;

			var nontakenModel = {

				observations : vm.nontaken.observations

			};

			planSamplingService.nontakenSample($scope.ctrl.idPlanSampling, $scope.ctrl.idSampling, $scope.ctrl.idSample, nontakenModel).then(function(response) {
				$scope.ctrl.reloadData();
				vm.loading = false;
				alertService.showSuccess('Muestra recibida en estado NO Tomada satisfactoriamente');
			}, function(response) {
				vm.loading = false;
			});
		});
	}

	vm.getURLDataFromImage = function() {
		if (vm.takenInfo.takePhoto) {
			var file = Upload.base64DataUrl(vm.takenInfo.takePhoto);

			file.then(function(response) {
				vm.takenInfo.takePhoto.urlData = response;
				vm.loadPhoto = false;
			});
		} else {
			vm.loadPhoto = false;
		}
	}

	function scrollToTake() {
		var takeElement = {};
		if (vmparent.sample.state == SAMPLE_STATE.ASIGNED.enumName) {
			takeElement = angular.element(document.getElementById('sampleElements'));
		} else {
			takeElement = angular.element(document.getElementById('take'));
		}
		$document.scrollToElement(takeElement, offset, duration);
	}

	function scrollToTakeForm() {
		var takeElement = angular.element(document.getElementById('takeForm-id'));
		$document.scrollToElement(takeElement, offset, duration);
	}

	vm.isExpanded = function() {
		$timeout(scrollToTakeForm, 100);
	}

	vm.isCollapsed = function() {
		if (angular.isUndefined(vmparent.sample))
			return;
		if (vmparent.sample.state != SAMPLE_STATE.SAMPLE_ELEMENT_CHECKED.enumName && vmparent.sample.state != SAMPLE_STATE.ASIGNED.enumName)
			return;
		$timeout(scrollToTake, 100);
	}

	init();

}
